import { FormWrapper } from '@app/features/form/Components/FormWrapper/FormWrapper';
import type { InventoryItem } from '../../types';
import { useInventoryFormConfig, type CategoryOption } from './form.config';

type Props = {
  data?: InventoryItem;
  categoryOptions: CategoryOption[];
  onSubmit: (formData: InventoryItem) => Promise<void>;
  /** Root className override; pass "" when hosting inside a modal to drop the default full-screen height. */
  extraClasses?: string;
};

export function InventoryForm({ data, categoryOptions, onSubmit, extraClasses }: Props) {
  const inventoryFormConfig = useInventoryFormConfig(categoryOptions);
  // New items default to consumable so the "at least one capability" rule starts satisfied.
  const defaultValues = data ?? { isConsumable: true, isSellable: false, isRentable: false };

  return (
    <FormWrapper<InventoryItem>
      defaultValues={defaultValues}
      fields={inventoryFormConfig}
      onSubmit={onSubmit}
      {...(extraClasses !== undefined ? { extraClasses } : {})}
    />
  );
}
